import { Card, CardBody, Col, Form, FormGroup, Input } from "reactstrap";
import { Btn, H4 } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Bio, MyProfiles, Save } from "../../../../Constant";
import { UserFormHead } from "./UserFormHead";
import CommonUserFormGroup from "../Common/CommonUserFormGroup";

const MyProfile = () => {
  const BioText = "On the other hand, we denounce with righteous indignation";

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={MyProfiles} />
        <CardBody>
          <Form onSubmit={(event) => event.preventDefault()}>
            <UserFormHead />
            <FormGroup>
              <H4 className="form-label mb-1">{Bio}</H4>
              <Input type="textarea" rows={5} defaultValue={BioText} />
            </FormGroup>
            <CommonUserFormGroup type="email" title="Email Address" placeholder="your-email@domain.com" />
            <CommonUserFormGroup type="password" title="Password" defaultValue="Password"/>
            <CommonUserFormGroup type="email" title="Website" placeholder="http://Uplor.com" />
            <div className="form-footer">
              <Btn color="primary" className="d-block">{Save}</Btn>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MyProfile;
